import { createReducer } from 'reduxsauce';
import actions from './actions';

const { Types } = actions;
const INITIAL_STATE = {
  stepsData: {},
  isLoadingSteps: false,
  isSubmittingResponse: false,
  submissionSuccess: false,
  error: null,
};

// Onboarding steps reducers
const loadOnboardingStepsRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoadingSteps: true,
    error: null,
  };
};

const loadOnboardingStepsSuccess = (state = INITIAL_STATE, { stepsData }) => {
  return {
    ...state,
    isLoadingSteps: false,
    stepsData,
    error: null,
  };
};

const loadOnboardingStepsFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isLoadingSteps: false,
    stepsData: {},
    error,
  };
};

// Onboarding response submission reducers
const submitOnboardingResponseRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isSubmittingResponse: true,
    submissionSuccess: false,
    error: null,
  };
};

const submitOnboardingResponseSuccess = (state = INITIAL_STATE, { responseData }) => {
  return {
    ...state,
    isSubmittingResponse: false,
    submissionSuccess: true,
    error: null,
  };
};

const submitOnboardingResponseFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isSubmittingResponse: false,
    submissionSuccess: false,
    error,
  };
};

export const HANDLERS = {
  // Onboarding steps handlers
  [Types.LOAD_ONBOARDING_STEPS_REQUEST]: loadOnboardingStepsRequest,
  [Types.LOAD_ONBOARDING_STEPS_SUCCESS]: loadOnboardingStepsSuccess,
  [Types.LOAD_ONBOARDING_STEPS_FAILURE]: loadOnboardingStepsFailure,

  // Response submission handlers
  [Types.SUBMIT_ONBOARDING_RESPONSE_REQUEST]: submitOnboardingResponseRequest,
  [Types.SUBMIT_ONBOARDING_RESPONSE_SUCCESS]: submitOnboardingResponseSuccess,
  [Types.SUBMIT_ONBOARDING_RESPONSE_FAILURE]: submitOnboardingResponseFailure,

  // Onboarding completion handler
};

export default createReducer(INITIAL_STATE, HANDLERS);
